import React, { useState } from "react";
import { graphql, navigate } from "gatsby";
import styled from "@emotion/styled";
import Img from "gatsby-image";
import { Helmet } from "react-helmet";

const Container = styled.div`
  margin: 3rem auto;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "Roboto";
  .gatsby-image-wrapper {
    width: 250px;
  }
`;

const ViewMapButton = styled.button`
  margin-top: 15px;
  text-transform: uppercase;
  border-radius: 5px;
  height: 30px;
  min-width: 125px;
  font-size: 16px;
  background-clip: padding-box;
  border: solid 5px transparent;
  background: #d8232a;
  color: #ffffff;
  padding: 0 20px;
  cursor: pointer;
  &:hover {
    background: darken(#c21f26);
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  font-size: 16px;
  height: 30px;
  text-align: center;
`;

export default function Home({ data }) {
  const [bibNumber, setBibNumber] = useState(0);
  const navigateToMap = (event) => {
    event.preventDefault();
    navigate(`/map/${bibNumber}`);
  };

  return (
    <Container>
      <Helmet title="50 States Virtual Challenge - Results Map"></Helmet>
      <Img fluid={data.file.childImageSharp.fluid} alt="logo" />
      <h1>Results Map</h1>
      <Form onSubmit={navigateToMap}>
        <label htmlFor="bib">Bib Number</label>
        <Input
          type="number"
          name="bib"
          id="bib"
          onChange={(e) => setBibNumber(e.target.value)}
        ></Input>

        <ViewMapButton type="submit">View Map</ViewMapButton>
      </Form>
    </Container>
  );
}

export const query = graphql`
  query {
    file(relativePath: { eq: "logos/50states-logo.png" }) {
      childImageSharp {
        fluid(maxWidth: 250) {
          ...GatsbyImageSharpFluid
          ...GatsbyImageSharpFluidLimitPresentationSize
        }
      }
    }
  }
`;
